module.exports = __webpack_public_path__ + "img/card-deliveryEJ.2b24ed87.svg";